import * as constants from "../constants";

export const getTypeLabel = (type) => {
  switch (type) {
    case constants.IMAGES:
      return 'Image';
    case constants.PANOS:
      return 'Panorama';
    case constants.VIDEOS:
      return 'Video'
    case constants.AUDIO:
      return 'Audio'
    case constants.EMBED:
      return 'Embed'
    default:
      return type;
  }
}
